import React, { useState, useEffect, useContext } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { Grid, TextField, Button } from '@material-ui/core';
import DataProvider from '../../../providers/DataProvider';
import { AuthContext } from '../../../providers/AuthProvider';
import Roles from '../../../models/enums/Roles';
import { useSelector } from 'react-redux';
import { positions } from '@material-ui/system';

export interface IFilterProps {
    submit: any;
    disabled?: boolean;
}

const Filter: React.FC<IFilterProps> = ({ submit, disabled = false }) => {

    const dataprovider = new DataProvider();
    const [companies, setCompanies] = useState<any[]>([]);
    const [departments, setDepartments] = useState<any[]>([]);
    const [selectedCompany, setCompany] = useState<any>({ id: "", name: "" });
    const [selectedDepartment, setDepartment] = useState<any>({ id: "", name: "" });
    const [userEmail, setUserEmail] = useState<string>("");
    const [userGeneral, setUserGeneral] = useState<string>("");
    const { user } = useContext(AuthContext);

    //@ts-ignore
    let searchState = useSelector(state => state.searchState);
    searchState = searchState.searchState;

    const onSubmit = (company: any, department: any, userEmail: string, userGeneral: string) => {

        if (company.id !== "") {
            submit(company, department, userEmail, userGeneral);
        }
    }

    const onCompanySelect = (id: string) => {
        dataprovider.getDepartments(id).then(data => {
            setDepartments(data.sort((a, b) => a.name > b.name ? 1 : -1));
            setDepartment({ id: "", name: "" });
        })
    }

    useEffect(() => {

        if (user?.role === Roles.manager) {
            onSubmit(searchState.company, searchState.department, userEmail, userGeneral);
        }

        if (user?.role === Roles.comp_manager) {
            dataprovider.getDepartments(searchState.company.id).then(data => {
                setDepartments(data.sort((a, b) => a.name > b.name ? 1 : -1));
                setDepartment({ id: "", name: "" });
            });
        }

        if (searchState.company.id !== "") {

            setCompany(searchState.company);
            setDepartment(searchState.department || { id: "", name: "" });
            onSubmit(searchState.company, searchState.department, userEmail, userGeneral);

        }

        if (user?.role !== Roles.comp_manager) {
            dataprovider.getCompanies().then(data => {
                setCompanies(data.sort((a, b) => a.name > b.name ? 1 : -1));
            });
        }
    }, []);

    if (user?.role === Roles.manager) {
        return <></>
    }

    return (
        <div style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            //dont render under the side bar, this needs to move right
            marginLeft: "100px",
            marginRight: "100px",
            width: "100%",
            position: "relative",
            justifyContent: "space-between",
        }}

        >
            {/* Left group: Company & Department (vertical) */}
            <div style={{ display: "flex", flexDirection: "column", width: "48%", gap: 12 }}>
                <Autocomplete
                    style={{
                        width: "100%",
                    }}
                    disabled={disabled || user?.role === Roles.comp_manager ? true : false}
                    id="company-combo"
                    options={companies}
                    getOptionSelected={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.name}
                    value={selectedCompany}
                    onChange={(event, data) => {
                        if (data) {
                            setCompany(data);
                            onCompanySelect(data.id);
                        } else {
                            setDepartments([]);
                            setDepartment({ id: "", name: "" });
                            setCompany({ id: "", name: "" });

                        }

                    }}
                    renderInput={(params) => <TextField {...params} label="Company" variant="outlined" />}
                />
                <Autocomplete
                    style={{
                        width: "100%",
                    }}
                    disabled={disabled}
                    id="department-combo"
                    options={departments}
                    value={selectedDepartment}
                    getOptionSelected={(option, value) => option.id === value.id}
                    getOptionLabel={(option) => option.name}
                    onChange={(event, data) => {
                        if (data) {
                            setDepartment(data);
                        } else {
                            setDepartment({ id: "", name: "" });
                        }

                    }}
                    renderInput={(params) => <TextField {...params} label="Departments" variant="outlined" />}
                />
            </div>

            {/* Right group: User Email & User General (vertical) + Search Button */}
            <div style={{ display: "flex", flexDirection: "column", width: "48%", gap: 12, alignItems: "flex-end" }}>
                <TextField
                    fullWidth
                    label="User Email"
                    variant="outlined"
                    value={userEmail}
                    onChange={(e) => setUserEmail(e.target.value)}
                    disabled={disabled}
                />
                <TextField
                    fullWidth
                    label="User General"
                    variant="outlined"
                    value={userGeneral}
                    onChange={(e) => setUserGeneral(e.target.value)}
                    disabled={disabled}
                />
                <Button color="primary" variant="outlined" disabled={disabled} onClick={() => { onSubmit(selectedCompany, selectedDepartment, userEmail, userGeneral) }}>
                    search
                </Button>
            </div>
        </div>
    );
}

export default Filter;